export default __webpack_public_path__ + "2d287e4b7fb26f3fc011da40c8894bb1.xlsx";